import { render } from "./MultiselectSelections.vue?vue&type=template&id=5671d11f&ts=true&lang=pug"
import script from "./MultiselectSelections.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiselectSelections.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__